// extracted by mini-css-extract-plugin
module.exports = {"hr":"ContactPage_hr__C5UCq","contactUsBtnGridContainer":"ContactPage_contactUsBtnGridContainer__rpNKj","singleBtnInContainer":"ContactPage_singleBtnInContainer__l5lxl"};